import { baseFabricFocusSelector, commonHighContrastHoverFocusStyles } from '@ms/app-commanding-ui/lib/styling';
import { DefaultFontStyles, FontWeights, HighContrastSelector, FontSizes } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';
export var getHeaderButtonStyles = memoizeFunction(function (headerColors) {
    var _a, _b;
    var hoverStyle = {
        backgroundColor: headerColors.hoverBackground,
        color: headerColors.hoverText || headerColors.defaultText,
        cursor: 'pointer',
        selectors: (_a = {},
            _a[HighContrastSelector] = {
                border: '2px dashed transparent',
                marginLeft: 2,
                marginRight: 2,
                marginTop: 2,
                height: 44,
            },
            _a),
    };
    var focusStyle = [
        hoverStyle,
        commonHighContrastHoverFocusStyles,
        {
            border: '1px solid #ffffff',
        },
    ];
    return {
        root: [
            DefaultFontStyles.large,
            {
                minHeight: 48,
                minWidth: 48,
                flexGrow: 1,
                lineHeight: 24,
                fontWeight: FontWeights.regular,
                whiteSpace: 'nowrap',
                height: '100%',
                padding: '0 10px',
                boxSizing: 'border-box',
                border: '1px solid transparent',
                borderRadius: 0,
                backgroundColor: headerColors.defaultBackground,
                color: headerColors.defaultText,
                cursor: 'default',
            },
            {
                selectors: (_b = {},
                    _b[baseFabricFocusSelector] = focusStyle,
                    _b),
            },
        ],
        textContainer: {
            minWidth: 0,
            flexGrow: 1,
            justifyContent: 'center',
            display: 'flex',
        },
        label: {
            lineHeight: 24,
            fontWeight: FontWeights.regular,
            fontSize: FontSizes.medium,
            padding: '13px 4px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            marginRight: 0,
            marginLeft: 8,
            paddingLeft: 0,
            paddingRight: 0,
        },
        rootHovered: hoverStyle,
        rootPressed: {
            backgroundColor: headerColors.pressedBackground,
            color: headerColors.defaultText,
        },
        icon: {
            paddingTop: 1,
            fill: headerColors.defaultText,
        },
    };
});
//# sourceMappingURL=HeaderButton.styles.js.map